import { ReferralProgram } from 'modules/strapi/types';

import { MarkdownWrapper } from '../MarkdownWrapper';

export interface IBenefitsProps {
  referralProgram: ReferralProgram;
}

export const Benefits = ({ referralProgram }: IBenefitsProps) => {
  const { benefits, blockchains } = referralProgram;

  const content = benefits
    .replace('{blockchains}', blockchains)
    .replace(/\\n/g, '\n');

  return <MarkdownWrapper>{content}</MarkdownWrapper>;
};
